export default __webpack_public_path__ + "media/music/0d677bd0c3f560862e8e5d2640c8a7fc.mp3";